// Taken from react activity
import React from "react";
import "./style.css";

const Wrapper = props => <div className="wrapper">{props.children}</div>;

export default Wrapper;